import classNames from 'classnames/bind';

import styles from './S03.module.scss';

import icon01 from '../../../assets/images/products/barrel/s03/icon01.svg';
import icon02 from '../../../assets/images/products/barrel/s03/icon02.svg';
import filter from '../../../assets/images/products/barrel/s03/filter.png';

const cx = classNames.bind(styles);

const S03 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <h2 className={cx('title')}>풀무원샘물 냉온수기를 편안하고 합리적으로</h2>
        <ul className={cx('list')}>
          <li>
            <img src={icon01} alt="" />
            <p>
              국내 업계 최초로 <span className={cx('point')}>*헤파필터</span> 장착으로 미생물과 세균을 걸러주는 필터링 효과{' '}
              <span className={cx('sub')}>(크로버 제조 냉온수기에 한함)</span>
            </p>
          </li>
          <li>
            <img src={icon02} alt="" />
            <p>
              기존 냉온수기 대비
              <br />
              전기료 20% 절감 및 소음 개선
            </p>
          </li>
        </ul>
        <div className={cx('inner')}>
          <div className={cx('image')}>
            <div className={cx('box')}>
              <img src={filter} alt="" />
            </div>
            <p className={cx('name')}>*헤파필터란?</p>
          </div>
          <p className={cx('text')}>
            냉온수기에서 물을 따를 때 외부 공기가 병 안으로 유입되지 않으면 병 내부가 진공 상태가 되어 물이 원활하게 나오지 않을 수
            있습니다. 따라서, 모든 냉온수기에는 외부 공기가 병 안으로 유입되는 구조가 적용되어 있습니다. 풀무원샘물 냉온수기는 국내 업계
            최초로 헤파필터를 적용해, 외부 공기가 병 안으로 유입되는 과정에서 공기 중 이물질과 일반 세균을 걸러내고, 병 속으로 들어가는
            공기를 보다 깨끗하게 관리함으로써 물의 신선함이 유지될 수 있게 하였습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default S03;
